import {
  APPROVAL_REQUEST_RELATED_TYPE,
  MANDATORY_NOTIFICATION_TYPES,
  type Notification,
} from '~/types/notifications';

/**
 * 通知的 `metadata` 是 JSON **字串**。解析失敗、不是物件時回 null，呼叫端退回只用頂層欄位。
 */
export function parseNotificationMetadata(raw: unknown): Record<string, unknown> | null {
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) return raw as Record<string, unknown>;
  if (typeof raw !== 'string' || !raw.trim()) return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

const nonEmpty = (value: unknown): string | null =>
  typeof value === 'string' && value.trim() ? value.trim() : null;

/**
 * 待審提醒（Business #1259）要打開的審批請求 ID。
 *
 * 以 `related_uuid` 為準（它就是詳情接口的 `request_id`）；metadata 只在 related_uuid 缺席時補位，
 * 解析失敗或缺欄位都不影響。不是審批關聯的通知回 null，照通用通知處理。
 */
export function approvalRequestIdOf(
  notification: Pick<Notification, 'related_type' | 'related_uuid' | 'metadata'>
): string | null {
  if (notification.related_type !== APPROVAL_REQUEST_RELATED_TYPE) return null;
  return (
    nonEmpty(notification.related_uuid) ??
    nonEmpty(parseNotificationMetadata(notification.metadata)?.request_id)
  );
}

/** 使用者能在通知設定裡關掉的類型（強制送達類型永遠不算） */
export const isConfigurableNotificationType = (type: string) =>
  !MANDATORY_NOTIFICATION_TYPES.includes(type);

/** 送出通知設定前把強制送達類型移出 disabled_types（後端也會忽略，但前端不送出誤導的設定） */
export function withoutMandatoryDisabled(disabledTypes: readonly string[]): string[] {
  return disabledTypes.filter(isConfigurableNotificationType);
}
